import packageInfo from '../../../package.json';

const baseApiUrl = 'https://fincomp.azure-api.net';
const functionAppUrl = 'https://fincomp.azure-api.net/FinComp-FunctionsApp';
const adminBaseUrl = 'https://fincomp.azure-api.net/admin';

export const environment = {
  production: true,
  apiUrl: '/api',
  appVersion: `${packageInfo.version}`,
  functionappCode: '',
  KPIDropdownsUrl: `${baseApiUrl}/KPI/GetAllKPIDropdownsData`,
  KPIDataUrl: `${baseApiUrl}/KPI/GetKPIGridData`,
  dealerUrl: `${baseApiUrl}/Dealer/GetDealers`,
  getPagesUrl: `${baseApiUrl}/KPI/GetPages`,
  getColumnsUrl: `${baseApiUrl}/KPI/GetColumns`,
  addKPIUrl: `${baseApiUrl}/KPI/AddKPI`,
  getCustomUrl: `${baseApiUrl}/KPI/GetCustomGroup`,
  addCustomGroupUrl: `${baseApiUrl}/KPI/CreateCustomGroup`,
  customgroupsdropdowndata: `${baseApiUrl}/Composite/GetCompositeDropdowns`,
  compositepagedropdowndata: `${baseApiUrl}/Composite/GetGraphAndResortByPageID`,
  deleteKpiUrl: `${baseApiUrl}/KPI/DeleteAdditionalKPI`,
  deleteCustomUrl: `${baseApiUrl}/KPI/DeleteCustomGroup`,
  getBocDropdownsData: `${baseApiUrl}/KPI/GetBocDropdownsData`,
  GetCustomSelectionDealers: `${baseApiUrl}/KPI/GetCustomSelectionDealers`,
  objectiveDropDownUrl: `${baseApiUrl}/Objectives/GetObjectivesDropdowns`,
  updateObjectiveActionsUrl: `${baseApiUrl}/Objectives/UpdateObjectiveActions`,
  getObjectiveGridTableData: `${baseApiUrl}/Objectives/GetObjectives`,
  getObjectiveDetails: `${baseApiUrl}/Objectives/GetObjectiveDetails`,
  getOrgDetailsByGroupCode: `${baseApiUrl}/Home/GetDealersByGroupCode`,
  getAddObjective: `${baseApiUrl}/Objectives/GetAddObjectives`,
  saveAddObjective: `${baseApiUrl}/Objectives/AddObjectives`,
  getVitalsDateDropDownData: `${baseApiUrl}/Vitals/GetVitalsDateDropdown`,
  getVitalsGridData: `${baseApiUrl}/Vitals/GetVitalsGridData`,
  getVitalsTrendData: `${baseApiUrl}/Vitals/GetVitalsTrend`,
  addObjectiveActionUrl: `${baseApiUrl}/Objectives/AddObjectiveActions`,
  getObjectiveActionUrl: `${baseApiUrl}/Objectives/GetObjectiveActions`,
  deleteObjectiveActionUrl: `${baseApiUrl}/Objectives/DeleteObjectiveActions`,
  compositePopupDataUrl: `${baseApiUrl}/Composite/GetCompositePopup`,
  editObjectiveUrl: `${baseApiUrl}/Objectives/EditObjectives`,
  archiveObjectivesUrl: `${baseApiUrl}/Objectives/ArchiveObjectives`,
  addNCObjective: `${baseApiUrl}/Objectives/AddNCObjective`,
  updateNCObjective: `${baseApiUrl}/Objectives/UpdateNCObjective`,
  archiveNCObjective: `${baseApiUrl}/Objectives/ArchiveNCObjective`,
  getNCObjectiveMonthlyData: `${baseApiUrl}/Objectives/GetNCObjectiveMonthlyData`,
  deleteNCObjectiveMonthValue: `${baseApiUrl}/Objectives/DeleteNCObjectiveMonthValue`,
  addNCObjectiveMonthValue: `${baseApiUrl}/Objectives/AddNCObjectiveMonthValue`,
  updateNCObjectiveMonthValue: `${baseApiUrl}/Objectives/UpdateNCObjectiveMonthValue`,
  getVitalsGridRowData: `${baseApiUrl}/Vitals/GetVitalsSelectionInfo`,
  getCompositeGrid: `${baseApiUrl}/Composite/GetCompositeGrid`,
  getComparisionGridData: `${baseApiUrl}/Composite/GetCompareDealersGrid`,
  getMyComparisionGridData: `${baseApiUrl}/Composite/GetMyCompareDealersGrid`,
  getMyTrendGridData: `${baseApiUrl}/Composite/GetMyTrendData`,
  getMyGroupTrendGridData: `${baseApiUrl}/Composite/GetGroupTrendData`,
  getOrganization: `${baseApiUrl}/GroupRoster/GetOrgDetails`,
  getGroupRosterData: `${baseApiUrl}/GroupRoster/GetRosterDetails`,
  kpiexportToExcel: `${baseApiUrl}/KPI/GetKPIExcelDataExport`,
  vitalsexportToExcel: `${baseApiUrl}/Vitals/GetVitalsGridExcelDataExport`,
  vitalstrendsexportToExcel: `${baseApiUrl}/Vitals/GetVitalsTrendExcelDataExport`,
  objectiveexportToExcel: `${baseApiUrl}/Objectives/ObjectivesExcelExport`,
  keyGraphData: `${baseApiUrl}/KeyGraph/GetKeyGraphData`,
  keyGraphDropdown: `${baseApiUrl}/KeyGraph/GetKeyGraphDropdownData`,
  getDepartmentData: `${baseApiUrl}/DepartmentAnalysis/GetDepartmentData`,
  departmentExcelData: `${baseApiUrl}/DepartmentAnalysis/DownloadDepartmentExcelData`,
  getOEMDepartments: `${baseApiUrl}/DepartmentAnalysis/GetOEMDepartments`,
  exportComparison: `${baseApiUrl}/Composite/CompareDealersExcelExport`,
  exportMyComparison: `${baseApiUrl}/Composite/MyCompareDealersExcelExport`,
  exportMyTrend: `${baseApiUrl}/Composite/GetMyTrendDataExcelExport`,
  exportGroupTrend: `${baseApiUrl}/Composite/GetGroupTrendDataExcelExport`,
  getPagesByGroupTypeId: `${baseApiUrl}/Composite/GetPagesByGroupTypeID`,
  getcompositeviewdropdown: `${baseApiUrl}/Composite/getcompositeviewdropdown`,
  getCompositeCompareWithDropdown: `${baseApiUrl}/Composite/GetCompareCompositeDealersDropdown`,
  getPageGrouping: `${baseApiUrl}/Authentication/role-based-pagegrouping`,
  getCustomGroups: `${baseApiUrl}/KPI/GetCustomGroup`,
  getGroupCompositeDates: `${baseApiUrl}/Home/GetGroupCompositeDates`,
  getDynamicDates: `${baseApiUrl}/Home/GetDynamicDates`,
  getTrendsGraphData: `${baseApiUrl}/Composite/GetDealerLine_TrendsGraphs`,
  getCommentsByType: `${baseApiUrl}/Comments/GetAllComments`,
  addComment: `${baseApiUrl}/Comments/Save`,
  deleteComment: `${baseApiUrl}/Comments/DeleteComment`,
  markCommentsAsRead: `${baseApiUrl}/Comments/MarkCommentsAsRead`,
  getGroupMembersList: `${baseApiUrl}/Comments/GetGroupMembersList`,
  getAllNotification: `${baseApiUrl}/Notifications/GetAllNotification`,
  deleteNotification: `${baseApiUrl}/Notifications/DeleteNotification`,
  markNotificationsAsRead: `${baseApiUrl}/Notifications/MarkNotificationsAsRead`,
  sendMailToAnalyst: `${baseApiUrl}/StatementUpload/SendMailToAnalyst`,
  sendMailForSupport: `${baseApiUrl}/StatementUpload/SendMailForSupport`,
  getRankingSummaryGrid: `${baseApiUrl}/Composite/GetRankingSummary`,

  GetSignalRToken: `${baseApiUrl}/SignalR/GetSignalRToken`,
  getPagesById: `${baseApiUrl}/Home/GetPages`,
  getColumnLinesById: `${baseApiUrl}/Home/GetColumnLines`,

  redirectGroupUrl: 'https://www.nada.org/nada/nada-20-group/',
  // Admin app endpoints
  getDmsData: `${adminBaseUrl}/ManualEntryStatement/GetDMSDropdowns`,
  getAnalystDetails: `${adminBaseUrl}/Authentication/GetAnalystDetails`,
  // Function app endpoints
  statementupload: `${functionAppUrl}/UploadDealerStatement`,
  getParticipationData: `${functionAppUrl}/GetParticipationData`,
  getReportDownloadData: `${functionAppUrl}/GetCompositeBooks`,
  getInputSheetDataUrl: `${functionAppUrl}/InputsheetData`,
  uploadInputSheetDataUrl: `${functionAppUrl}/UpdateInputSheetData`,
  getInputSheetInstructionsUrl: `${functionAppUrl}/GetInputSheetInstructions`,
  groupCompositeDetails: `${functionAppUrl}/GetGroupCompositeDetails`,
  generateCompositeExcel: `${functionAppUrl}/GenerateCustomComposite`,
  getPrintRequestData: `${functionAppUrl}/PrintRequests`,
  getPrintRequestPopup: `${functionAppUrl}/PrintRequestPopup`,
  savePrintRequestPopupSave: `${functionAppUrl}/SavePrintRequestPopup`,
  GetCompositeGenerationZip: `${functionAppUrl}/GetCompositeGenerationZip`,

  // Impx endpoints
  userCommittes: 'https://nadahubintegrationapim.azure-api.net/live/v1/users',
};
